import type { CompositeCardProviderProps } from '@mf-types/remote/compiled-types/components/CompositeCard/CompositeCardProvider';
import { AsyncSuspenseFallbackLoader } from 'components/AsyncSuspenseFallbackLoader/AsyncSuspenseFallbackLoader';
import { MemoizedErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
import { Suspense } from 'react';
import { withRemoteLoading } from 'shared/utils/remoteLoader';

const CompositeCard = withRemoteLoading<CompositeCardProviderProps>('CompositeCard');

const AsyncCompositeCard = (props: CompositeCardProviderProps) => {
  return (
    <MemoizedErrorBoundary>
      <Suspense fallback={<AsyncSuspenseFallbackLoader />}>
        <CompositeCard {...props} />
      </Suspense>
    </MemoizedErrorBoundary>
  );
};

export default AsyncCompositeCard;
